import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { parseUnixSecondsDate } from 'helpers/time';

export const TimeRange = ({ startTimestamp, endTimestamp }) => {
  const startTime = parseUnixSecondsDate(startTimestamp);
  const endTime = parseUnixSecondsDate(endTimestamp);

  return (
    <span className="time-range">
      <FormattedMessage
        id="reservation.date-range"
        defaultMessage="{startTime, time, short} - {endTime, time, short}"
        values={{
          startTime,
          endTime,
        }}
      />
    </span>
  );
};

const TimeStampShape = PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired;

TimeRange.propTypes = {
  startTimestamp: TimeStampShape,
  endTimestamp: TimeStampShape,
};
